module.exports = __webpack_public_path__ + "img/item4.65d67440.png";